import { render, staticRenderFns } from "./NewSignupPage.vue?vue&type=template&id=1c1b0cc4&scoped=true"
import script from "./NewSignupPage.vue?vue&type=script&lang=js"
export * from "./NewSignupPage.vue?vue&type=script&lang=js"
import style0 from "./NewSignupPage.vue?vue&type=style&index=0&id=1c1b0cc4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c1b0cc4",
  null
  
)

export default component.exports